'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DynamicLayout = require('@narvar/nth-kit-dynamic-layout-next');
var nthBitGrid = require('@narvar/nth-bit-grid');
var index$4 = require('../../packs/OrderLookup/index.js');
var index$3 = require('../../packs/ItemSelector/index.js');
var index$2 = require('../../packs/ReturnReasons/index.js');
require('../../packs/Pudo/RootElm/PudoRaw.js');
var wrapped = require('../../packs/Pudo/RootElm/wrapped.js');
var index$1 = require('../../packs/ReviewSummary/index.js');
var index = require('../../packs/Confirmation/index.js');
require('@babel/runtime/helpers/extends');
require('../../packs/RefundMethods/RefundMethodsRaw.js');
require('react-query');
require('@narvar/nth-hook-loma');
require('@narvar/nth-hook-global-settings');
require('@narvar/nth-bit-error-boundary');
require('@apollo/client');
require('@apollo/client/link/error');
require('@narvar/apollo-client');
require('@narvar/nth-hook-translations');
require('@narvar/nth-hook-settings');
require('@narvar/nth-hook-theme');
require('@narvar/nth-hook-context-analytics');
require('jwt-decode');
var NthFeature = require('./NthFeature.js');
var CsrSignInForm = require('../../components/CsrSignInForm/CsrSignInForm.js');
var ReturnsLayout_module = require('./ReturnsLayout.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DynamicLayout__default = /*#__PURE__*/_interopDefaultLegacy(DynamicLayout);

/* eslint-disable react/prop-types */
const View = props => {
  if (!props) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const {
    children
  } = props;
  // this overrides the default max-width in the container used by track
  return /*#__PURE__*/React__default["default"].createElement(nthBitGrid.Container, {
    maxWidth: "100%"
  }, children);
};
const ReturnsLayout = _ref => {
  let {
    orderLookup,
    itemSelector,
    returnReasons,
    pudo,
    review,
    confirmation
  } = _ref;
  // this logic is mostly copied from nth-kit-dynamic-layout-next. it
  // determines whether to query for the mobile or desktop layout JSON from settings.
  // returns layout JSON has a slightly different structure, so the query will
  // always return both layouts. we need to determine which one to actually use.
  const DEFAULT_REM = 16;
  const desktopBreakPointMinWidth = 768;
  const windowWidth = (DynamicLayout.useWindowSize({
    fixedSize: true
  }).width || 0) / DynamicLayout.useRem();
  const breakpoints = {
    [DynamicLayout.LayoutTree.Devices.DESKTOP]: desktopBreakPointMinWidth / DEFAULT_REM
  };
  const possibleDevicePerWindowWidth = () => {
    if (!windowWidth) return undefined;
    return windowWidth >= breakpoints[DynamicLayout.LayoutTree.Devices.DESKTOP] ? DynamicLayout.LayoutTree.Devices.DESKTOP : DynamicLayout.LayoutTree.Devices.MOBILE;
  };
  const deviceLayoutName = possibleDevicePerWindowWidth() || DynamicLayout.LayoutTree.Devices.DESKTOP;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ReturnsLayout_module["default"].pageWrapper
  }, /*#__PURE__*/React__default["default"].createElement(DynamicLayout__default["default"], {
    view: View,
    fixedSize: true,
    transformLayout: layout => layout && layout[deviceLayoutName],
    feature: options => {
      if (!options) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
      const {
        node
      } = options;
      switch (node.name) {
        case 'Order Lookup Pack':
          if (!orderLookup) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          if (orderLookup !== null && orderLookup !== void 0 && orderLookup.error) {
            const isCsrSignIn = CsrSignInForm.getSessionStorageItem('csrSignIn') === 'true';
            if (isCsrSignIn) {
              CsrSignInForm.setSessionStorageItem('csrSignIn', null);
              window.location.href = `${window.location.origin}${window.location.pathname}/csr-login?error_code=500`;
              return /*#__PURE__*/React__default["default"].createElement("div", {
                className: ReturnsLayout_module["default"].desktopHeightWrapper
              });
            }
          }
          return /*#__PURE__*/React__default["default"].createElement(DynamicLayout__default["default"], {
            fixedSize: true,
            view: View,
            transformLayout: () => {
              var _node$options, _node$options$customF, _node$options$customF2;
              const layout = (_node$options = node.options) === null || _node$options === void 0 ? void 0 : (_node$options$customF = _node$options.customFeature) === null || _node$options$customF === void 0 ? void 0 : (_node$options$customF2 = _node$options$customF.settings) === null || _node$options$customF2 === void 0 ? void 0 : _node$options$customF2.trackPageLayout;
              return layout[deviceLayoutName];
            },
            feature: options => {
              if (!options) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
              const {
                node
              } = options;
              switch (node.name) {
                case 'Order Lookup Form':
                  return /*#__PURE__*/React__default["default"].createElement("div", {
                    className: ReturnsLayout_module["default"].desktopHeightWrapper
                  }, /*#__PURE__*/React__default["default"].createElement(index$4.OrderLookup, orderLookup));
                default:
                  return /*#__PURE__*/React__default["default"].createElement(NthFeature["default"], {
                    node: node,
                    sticky: true
                  });
              }
            }
          });
        case 'Item Selector Pack':
          if (!itemSelector) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: ReturnsLayout_module["default"].stepWrapper
          }, /*#__PURE__*/React__default["default"].createElement(index$3.ItemSelector, itemSelector));
        case 'Return Reasons Pack':
          if (!returnReasons) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: ReturnsLayout_module["default"].stepWrapper
          }, /*#__PURE__*/React__default["default"].createElement(index$2.ReturnReasons, returnReasons));
        case 'Pudo Pack':
          if (!pudo) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: ReturnsLayout_module["default"].stepWrapper
          }, /*#__PURE__*/React__default["default"].createElement(wrapped.Pudo, pudo));
        case 'Review Summary Pack':
          if (!review) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: ReturnsLayout_module["default"].stepWrapper
          }, /*#__PURE__*/React__default["default"].createElement(index$1.ReviewSummary, review));
        case 'Confirmation Pack':
          if (!confirmation) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement("div", {
            className: ReturnsLayout_module["default"].stepWrapper
          }, /*#__PURE__*/React__default["default"].createElement(index.Confirmation, confirmation));
        default:
          return /*#__PURE__*/React__default["default"].createElement(NthFeature["default"], {
            node: node,
            sticky: Boolean(orderLookup)
          });
      }
    }
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = ReturnsLayout;
